export enum TransactionErrorCodes {
  // Account Codes
  // ACH
  InvalidRoutingNumber = 'A-001',
  AccountNotFound = 'A-002',
  InvalidAccountNumber = 'A-003',
  AccountClosed = 'A-005',
  UnrecognizedBankAccount = 'A-007',
  UnknownAccountRetryable = 'A-010',
  // Zelle
  InvalidEmail = 'A-004',
  InvalidZelleAccount = 'A-006',
  // Recipient Codes
  InvalidAddress = 'R-001',
  UnknownRecipientRetryable = 'R-010',
  // Funding Source Codes
  FundingSourceNotFound = 'F-001',
  // Authentication Codes
  InvalidCredentials = 'I-001',
  // Network Codes
  ServiceNotReached = 'N-001',
  // Provider Connectivity Code
  ProviderConnectivityIssue = 'P-001',
}

export interface ClaimError {
  message: string;
  retryable: boolean;
  errorCode?: TransactionErrorCodes;
}

export const TransactionErrorDisplay: Record<TransactionErrorCodes, string> = {
  [TransactionErrorCodes.AccountNotFound]:
    'There was no account found with the provided information. Please ensure the account information is provided before initiating a claim.',
  [TransactionErrorCodes.FundingSourceNotFound]:
    'There was no funding source found associated with this program. Please contact support to resolve.',
  [TransactionErrorCodes.InvalidAccountNumber]:
    'The provided account number is invalid. Please double check the number and try again.',
  [TransactionErrorCodes.InvalidAddress]:
    'The provided address is invalid. Please double check the address and try again.',
  [TransactionErrorCodes.InvalidEmail]:
    'The provided email address is in an invalid format. Please double check the email and try again.',
  [TransactionErrorCodes.InvalidRoutingNumber]:
    'The provided routing number is invalid. Please double check the number and try again.',
  [TransactionErrorCodes.InvalidCredentials]:
    'There was an issue connecting to the payment provider. Please wait a moment and try again.',
  [TransactionErrorCodes.ServiceNotReached]:
    'There was an issue connecting to the payment provider. Please wait a moment and try again.',
  [TransactionErrorCodes.AccountClosed]:
    'Your account was closed by either you or the financial institution.',
  [TransactionErrorCodes.UnrecognizedBankAccount]:
    'Your bank account details are not recognized by your financial institution.',
  [TransactionErrorCodes.InvalidZelleAccount]:
    'Your Zelle account appears to be restricted. Please contact Zelle Support for more information.',
  [TransactionErrorCodes.UnknownAccountRetryable]:
    'There was an error when processing your payment. Please try again. If you continue experiencing issues with your payment, please contact support.',
  [TransactionErrorCodes.UnknownRecipientRetryable]:
    'There was an error when processing your payment. Please try again. If you continue experiencing issues with your payment, please contact support.',
  [TransactionErrorCodes.ProviderConnectivityIssue]:
    'There was an issue connecting to the payment provider. Please wait a moment and try again.',
};
